<template>
  <div class="transparent" ref="modalWrap"
    @touchstart="(e)=>{e.preventDefault;}"
  >
    <div
      :style="{
      transform: `translate(${x}px, ${y}px)`,
      width: `${w * zoomRatio}px`,
      height: `${h * zoomRatio}px`,
    }"
      ref="window"
      class="window"
      @mousedown="dragStart"
      @touchstart="dragStart"
    >
      <div class="m-title">
        <span v-text="title"></span>
        <button class="close" @click="close" @touchstart="close">
          <span aria-hidden="true" class="btn-close">&times;</span>
        </button>
      </div>
      <video
        :class="{ loaded: loadedVideo }"
        :muted="!config.audio"
        :src="src"
        preload="metadata"
        playsinline
        @loadedmetadata="loaded"
        ref="myVideo"
        controls
        controlslist="nodownload"
        disablepictureinpicture
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: "VideoModal",
  props: {
    src: String,
    config: Object,
    title: String
  },
  data() {
    return {
      initPosition: {
        x: 0,
        y: 0
      },
      x: 0,
      y: 120,
      w: 0,
      h: 0,
      zoomRatio: 1,
      loadedVideo: false,
      dragging: false
    };
  },
  created() {
    window.addEventListener("mousemove", this.dragMove, { passive: false });
    window.addEventListener("touchmove", this.dragMove, { passive: false });
    window.addEventListener("mouseup", this.dragEnd, { passive: false });
    window.addEventListener("touchend", this.dragEnd, { passive: false });
  },
  mounted() {
    console.log("mounted");
    this.initPosition = { x: 0, y: 0 };
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.dragMove);
    window.removeEventListener("touchmove", this.dragMove);
    window.removeEventListener("mouseup", this.dragEnd);
    window.removeEventListener("touchend", this.dragEnd);
  },
  methods: {
    loaded() {
      console.log("loaded");
      this.w = this.$refs.myVideo.clientWidth;
      this.h = this.$refs.myVideo.clientHeight;

      let zoomWidth = 1,
        zoomHeight = 1;
      if (this.w > window.innerWidth) {
        zoomWidth = window.innerWidth / (this.w + 40);
      }

      if (this.h > window.innerHeight) {
        zoomHeight = window.innerHeight / (this.h + 40);
      }

      this.zoomRatio = Math.min(zoomWidth, zoomHeight);

      this.$nextTick(() => {
        this.x =
          (this.$refs["modalWrap"].clientWidth -
            this.$refs["window"].clientWidth) /
          2;
        this.y =
          (this.$refs["modalWrap"].clientHeight -
            this.$refs["window"].clientHeight) /
          2;

        this.loadedVideo = true;
      });
    },
    close() {
      console.log("close");
      this.$emit("closemodal");
    },
    dragStart(e) {
      console.log("dragStart");
      e.preventDefault();
      e.stopPropagation();
      let point;
      this.dragging = true;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }
      this.initPosition = {
        x: point.pageX - this.x,
        y: point.pageY - this.y
      };
    },
    dragMove(e) {
      e.preventDefault();
      e.stopPropagation();
      let point;
      if (this.dragging) {
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        this.x = point.pageX - this.initPosition.x;
        this.y = point.pageY - this.initPosition.y;
      }
    },
    dragEnd(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragging = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.window {
  position: fixed;
  top: 0;
  left: 0;
  background: #eee;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);
  z-index: 1025;
  border-radius: 10px;
  padding: 10px;
}

.m-title {
  height: 1em;
  font-size: 1em;
  padding: 0;
  margin: 0;
  line-height: 1em;
}

video {
  transform-origin: top left;
}

video.loaded {
  width: 100%;
  max-height: calc(100% - 1em);
}

button {
  position: absolute;
  top: 0;
  right: 0;
}

.transparent {
  background: transparent;
  pointer-events: none;

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1020;
}

.transparent * {
  pointer-events: initial;
}
</style>
